module.exports = __webpack_public_path__ + "media/images/patterns/wrapper-top-5f2d38ac6e72bdd7ffa131fa11da1756.svg";